import { createAction, props } from '@ngrx/store';

import { PatternSearchResult } from '@search/models/pattern-search-result';

export const searchByPattern = createAction('[Pattern Search] Search By Pattern', props<{ searchPattern: string }>());
export const searchByPatternSuccess = createAction('[Pattern Search] Search By Pattern Success', props<{ patternSearchResults: PatternSearchResult[] }>());
export const searchByPatternFailed = createAction('[Pattern Search] Search By Pattern Failed');

export const patternResultChanged = createAction('[Pattern Search] Pattern Result Changed', props<{ patternResults: PatternSearchResult[] }>());